export class User {
  id: number;
  name: string;
  email: string;
  should_reset_password: boolean;
  token: string;
}
